import { coreApi } from '@cp/shared/api/core';
import { BlockNamesRequest, BlockRouteRequest, ClientRouteBlock } from '@common/model/blocks';
import { CoreClientBlocksApiMetaTags, coreClientBLocksApiMetaTagTypes } from '../lib/const';

const BASE_URL = '/client/blocks/route';

export const coreClientBlocksApi = coreApi.enhanceEndpoints({ addTagTypes: coreClientBLocksApiMetaTagTypes }).injectEndpoints({
  endpoints: (builder) => ({
    findPageBlocks: builder.query<ClientRouteBlock[], BlockNamesRequest & BlockRouteRequest>({
      query: ({ names, routeId }) => ({
        url: `${BASE_URL}/${routeId}${!!names?.length ? `?name=${names.join('&name=')}` : ''}`,
        method: 'get',
      }),
      providesTags: (result, error, { routeId }) => [{ type: CoreClientBlocksApiMetaTags.ClientBlocks, id: `route_blocks_${routeId}` }],
    }),
  }),
});
